<template>
<div id="LayoutIndex">
    <AppHeader @collapse='() => collapsed = !collapsed'/>
    <div class="app-container">
        <AppSidebar :collapsed='collapsed'/>
        <AppContent :collapsed='collapsed'/>
    </div>
</div>
</template>
<script>
import Core from '../../core'

import AppHeader from  './components/AppHeader.vue'
import AppSidebar from './components/AppSidebar.vue'
import AppContent from './components/AppContent.vue'

export default {
    components: {
        AppHeader,
        AppSidebar,
        AppContent
    },
    data() {
        return {
            collapsed: false,
        }
    },
}
</script>

<style lang="scss" scoped>
#LayoutIndex {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    background-color: #E8ECF0;
    .app-container {
        height: calc(100vh - 50px);
        width: 100%;
        display: flex;
        overflow: hidden;
    }
}
</style>
